/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityReportResource } from './';
import {
    ActivityReportResourceFromJSON,
    ActivityReportResourceFromJSONTyped,
    ActivityReportResourceToJSON,
} from './';
import type { ActivityReportStatusResource } from './';
import {
    ActivityReportStatusResourceFromJSON,
    ActivityReportStatusResourceFromJSONTyped,
    ActivityReportStatusResourceToJSON,
} from './';
import type { PaymentMethod } from './';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
} from './';
import type { ReportTypeResource } from './';
import {
    ReportTypeResourceFromJSON,
    ReportTypeResourceFromJSONTyped,
    ReportTypeResourceToJSON,
} from './';
import type { TemporalUnitResource } from './';
import {
    TemporalUnitResourceFromJSON,
    TemporalUnitResourceFromJSONTyped,
    TemporalUnitResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SimpleActivityReportResource
 */
export interface SimpleActivityReportResource extends ActivityReportResource {
}

/**
 * Check if a given object implements the SimpleActivityReportResource interface.
 */
export function instanceOfSimpleActivityReportResource(value: object): value is SimpleActivityReportResource {
    return true;
}

export function SimpleActivityReportResourceFromJSON(json: any): SimpleActivityReportResource {
    return SimpleActivityReportResourceFromJSONTyped(json, false);
}

export function SimpleActivityReportResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimpleActivityReportResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ActivityReportResourceFromJSONTyped(json, ignoreDiscriminator),
    };
}

export function SimpleActivityReportResourceToJSON(value?: SimpleActivityReportResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ActivityReportResourceToJSON(value, true),
    };
}

